import { Group, Paper, Title } from '@mantine/core';
import { modals } from '@mantine/modals';
import { IconTrash } from '@tabler/icons-react';
import { useMutation } from '@tanstack/react-query';
import { RowSelectionState } from '@tanstack/table-core';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import OrganisationsTable from '../../components/organisations-table/organisations-table';

import { ErrorPage } from './page.error';
import styles from './page.module.css';

import { accountsApi } from '@accounts/data-access';
import { useColFilters, usePagination } from '@data-access';
import { organisationApi } from '@organisations/data-access';
import {
  ActionsMenu,
  ActionsMenuItem,
  FullMainHeight,
  TsrButtonLink,
} from '@ui';

export function OrganisationsListPage() {
  const { t } = useTranslation();
  const [rowSelection, setRowSelection] = useState<RowSelectionState>({});
  const [filters, , resetFilters] = useColFilters('organisations');
  const [, setPagination] = usePagination('organisations');

  const deleteMany = useMutation({
    mutationFn: organisationApi.deleteMany,
    onSuccess: () => {
      setRowSelection({});
    },
  });

  const items: ActionsMenuItem[] = [
    {
      type: 'action',
      label: 'Supprimer',
      color: 'red',
      icon: IconTrash,
      onClick: () => {
        modals.openConfirmModal({
          title: t('organisations.delete_title'),
          content: t('organisations.delete_message'),
          labels: { confirm: t('common.delete'), cancel: t('common.cancel') },

          onConfirm: () => {
            if (rowSelection.all) {
              deleteMany.mutate({
                ids: [],
                all: true,
                selectedFilters: filters,
              });
            } else {
              const ids = Object.keys(rowSelection).map((id) => Number(id));
              deleteMany.mutate({
                ids,
              });
            }
          },
        });
      },
    },
  ];

  useEffect(() => {
    resetFilters();
    setPagination({ pageIndex: 0, pageSize: 25 });
  }, []);

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Header>
        <Paper>
          <Group justify="space-between">
            <Title order={2}>{t('organisations.list_page_title')}</Title>
            <Group>
              <TsrButtonLink to="/organisations/create">
                {t('organisations.add_organisation')}
              </TsrButtonLink>
              <ActionsMenu items={items}>
                <ActionsMenu.Button />
              </ActionsMenu>
            </Group>
          </Group>
        </Paper>
      </FullMainHeight.Header>
      <FullMainHeight.Content>
        <OrganisationsTable
          rowSelection={rowSelection}
          setRowSelection={setRowSelection}
        />
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

OrganisationsListPage.Error = ErrorPage;

export default OrganisationsListPage;
